import config from "../app-config";
import serverFetch from "../utils/serverFetch";

export const create_new_staff = async (body) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/staff`,
        method: "POST",
        body: JSON.stringify(body)
    })
}

export const get_all_staff = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/staff`,
        method: "GET"
    })
}

export const get_staff_by_id = async (id) => {
    if (!id) return { error: "No staff id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/staff/id/${id}`,
        method: "GET"
    })
}

export const update_staff = async (id, body) => {
    if (!id) return { error: "No staff id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/staff/id/${id}`,
        method: "PUT",
        body: JSON.stringify(body)
    })
}

export const delete_staff = async (id) => {
    if (!id) return { error: "No staff id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/staff/id/${id}`,
        method: "DELETE"
    })
}

export const duplicate_staff = async (id) => {
    if (!id) return { error: "No staff id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/staff/duplicate/id/${id}`,
        method: "POST"
    })
}

export const upload_staff_csv = async (csv_text, mode = "add") => {
    return await serverFetch({
        endpoint: `${config.endpoint}/staff/upload-csv`,
        method: "POST",
        body: JSON.stringify({ csv_text, mode })
    })
}
